import { Link } from "react-router-dom";

function Breadcrumb({ items = [], current }) {
  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb__list">
        <li className="breadcrumb__item">
          <Link to="/" className="breadcrumb__link">
            <i className="bi bi-house-door-fill breadcrumb__home" />
            Home
          </Link>
        </li>
        {items.map((item) => (
          <li className="breadcrumb__item" key={item.label}>
            <i className="bi bi-chevron-right breadcrumb__sep" />
            {item.to ? (
              <Link to={item.to} className="breadcrumb__link">
                {item.label}
              </Link>
            ) : (
              <span className="breadcrumb__current">{item.label}</span>
            )}
          </li>
        ))}
        {current && (
          <li className="breadcrumb__item breadcrumb__item--current">
            <i className="bi bi-chevron-right breadcrumb__sep" />
            <span className="breadcrumb__current">
              <i className="bi bi-stars breadcrumb__sparkle" />
              {current}
            </span>
          </li>
        )}
      </ol>
    </nav>
  );
}

export default Breadcrumb;